var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoConnection = function SvgNoConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "#ffdba9",
    "data-original": "#FFDBA9",
    className: "",
    "data-old_color": "#ffdba9",
    style: {
      fill: "#FF9012"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-6.3125-.238281-12.570312-.6875-18.769531l-114.035156-114.035157c-35.40625-37.644531-85.640625-61.195312-141.277344-61.195312-106.972656 0-194 87.027344-194 194 0 55.636719 23.550781 105.871094 61.195312 141.28125l114.035157 114.03125c6.199219.449219 12.457031.6875 18.769531.6875 141.386719 0 256-114.613281 256-256zm0 0",
    fill: "#fec374",
    "data-original": "#FEC374",
    className: "",
    "data-old_color": "#fec374",
    style: {
      fill: "#DD7E13"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m423.027344 256c0 92.246094-74.78125 167.027344-167.027344 167.027344s-167.027344-74.78125-167.027344-167.027344 74.78125-167.027344 167.027344-167.027344 167.027344 74.78125 167.027344 167.027344zm0 0",
    fill: "#fff",
    "data-original": "#FFF",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m423.03125 256c0 92.25-74.78125 167.03125-167.03125 167.03125v-334.0625c92.25 0 167.03125 74.78125 167.03125 167.03125zm0 0",
    fill: "#fef4cb",
    "data-original": "#FEF4CB",
    className: "",
    "data-old_color": "#fef4cb",
    style: {
      fill: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.042969 341.113281c0 18.800781-15.242188 34.042969-34.042969 34.042969s-34.042969-15.242188-34.042969-34.042969 15.242188-34.042969 34.042969-34.042969 34.042969 15.242188 34.042969 34.042969zm0 0",
    fill: "#8b8992",
    "data-original": "#8B8992",
    className: "",
    "data-old_color": "#8b8992",
    style: {
      fill: "#0C87FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.039062 341.109375c0 18.8125-15.238281 34.050781-34.039062 34.050781v-68.089844c18.800781 0 34.039062 15.238282 34.039062 34.039063zm0 0",
    fill: "#57555c",
    "data-original": "#57555C",
    className: "",
    "data-old_color": "#57555c",
    style: {
      fill: "#0C87FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 256.519531c-24.414062 0-47.636719 10.554688-63.710938 28.953125l-1.027343 1.175782 22.640625 19.777343 1.027344-1.171875c10.363281-11.867187 25.332031-18.671875 41.070312-18.671875s30.707031 6.804688 41.070312 18.671875l1.027344 1.171875 22.640625-19.777343-1.027343-1.175782c-16.074219-18.398437-39.296876-28.953125-63.710938-28.953125zm0 0",
    fill: "#8b8992",
    "data-original": "#8B8992",
    className: "",
    "data-old_color": "#8b8992",
    style: {
      fill: "#0C87FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.738281 286.648438-22.636719 19.78125-1.03125-1.179688c-10.359374-11.859375-25.332031-18.671875-41.070312-18.671875v-30.058594c24.421875 0 47.640625 10.550781 63.710938 28.949219zm0 0",
    fill: "#57555c",
    "data-original": "#57555C",
    className: "",
    "data-old_color": "#57555c",
    style: {
      fill: "#0C87FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 200.265625c-37.832031 0-74.042969 16.148437-99.351562 44.300781l-1.039063 1.160156 22.355469 20.09375 1.042968-1.160156c19.613282-21.820312 47.675782-34.335937 76.992188-34.335937s57.378906 12.515625 76.992188 34.335937l1.042968 1.160156 22.355469-20.09375-1.039063-1.160156c-25.308593-28.152344-61.519531-44.300781-99.351562-44.300781zm0 0",
    fill: "#8b8992",
    "data-original": "#8B8992",
    className: "",
    "data-old_color": "#8b8992",
    style: {
      fill: "#0C87FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.390625 245.730469-22.359375 20.089843-1.042969-1.160156c-19.609375-21.820312-47.667969-34.332031-76.988281-34.332031v-30.058594c37.828125 0 74.039062 16.140625 99.351562 44.300781zm0 0",
    fill: "#57555c",
    "data-original": "#57555C",
    className: "",
    "data-old_color": "#57555c",
    style: {
      fill: "#0C87FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.46875 203.976562c-16.785156-18.679687-36.835938-33.414062-59.605469-43.785156-23.574219-10.746094-48.761719-16.191406-74.863281-16.191406s-51.289062 5.445312-74.863281 16.1875c-22.769531 10.375-42.820313 25.109375-59.605469 43.789062l-1.042969 1.160157 22.363281 20.089843 1.042969-1.160156c28.546875-31.78125 69.410157-50.003906 112.105469-50.003906s83.554688 18.222656 112.105469 50.003906l1.042969 1.160156 22.359374-20.089843zm0 0",
    fill: "#8b8992",
    "data-original": "#8B8992",
    className: "",
    "data-old_color": "#8b8992",
    style: {
      fill: "#0C87FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.511719 205.140625-22.363281 20.089844-1.039063-1.160157c-28.550781-31.78125-69.410156-50.011718-112.109375-50.011718v-30.058594c26.101562 0 51.289062 5.449219 74.859375 16.191406 22.769531 10.367188 42.832031 25.097656 59.609375 43.789063zm0 0",
    fill: "#57555c",
    "data-original": "#57555C",
    className: "",
    "data-old_color": "#57555c",
    style: {
      fill: "#0C87FA"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 62c-106.972656 0-194 87.027344-194 194s87.027344 194 194 194 194-87.027344 194-194-87.027344-194-194-194zm0 30c39.824219 0 76.375 14.273438 104.816406 37.96875l-230.847656 230.847656c-23.695312-28.441406-37.96875-64.992187-37.96875-104.816406 0-90.429688 73.570312-164 164-164zm0 328c-39.824219 0-76.378906-14.273438-104.816406-37.96875l230.847656-230.847656c23.695312 28.441406 37.96875 64.992187 37.96875 104.816406 0 90.429688-73.570312 164-164 164zm0 0",
    fill: "#ff001e",
    "data-original": "#FF001E",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 62v30c39.828125 0 76.378906 14.269531 104.820312 37.96875l-104.820312 104.820312v42.421876l126.03125-126.03125c23.699219 28.441406 37.96875 64.992187 37.96875 104.820312 0 90.429688-73.570312 164-164 164v30c106.96875 0 194-87.03125 194-194s-87.03125-194-194-194zm0 0",
    fill: "#ea0016",
    "data-original": "#EA0016",
    className: "active-path"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-connection.01dea408.svg";
export { ForwardRef as ReactComponent };